export const ONE_LINE_HEIGHT = 24;
export const MAX_LINES = 7;
export const VERY_LARGE_LINE_LIMIT = 100000;
